// extracted by mini-css-extract-plugin
export default {"products":"Products_products__stW4z"};